import { ElMessage } from 'element-plus';

import setFbq from '@/assets/js/fbq';
import ttq from '@/assets/js/tt-api';
import { Emarsys } from '@/common/emarsysSdk';
import { SDUtils } from '@/common/sensorsdata';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('fbq', setFbq);
  nuxtApp.provide('ttq', ttq);
  nuxtApp.provide('message', ElMessage);
  nuxtApp.vueApp.provide('fbq', setFbq);
  nuxtApp.vueApp.provide('ttq', ttq);
  if (process.client) {
    window.voo_sensors = SDUtils;
    SDUtils.syncSensorsIdentity();
    (window as any).EmarsysTrack = Emarsys;

    /**
     * @description: 原生 flat 方法的 polyfill
     * @param {*} depth 深度，默认1
     * @return {*}
     */
    if (!Array.prototype.flat) {
      (Array.prototype as any).flat = function (depth = 1) {
        if (!this.length) return [];
        const reduceCb = (acc: any[], val: any) =>
          acc.concat(Array.isArray(val) ? val.flat(depth - 1) : val);
        return depth > 1
          ? this.reduce(reduceCb, [])
          : this.reduce((acc: any[], val: any) => acc.concat(Array.isArray(val) ? val : [val]), []);
      };
    }
  }
});
